var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',[_c('GenericLoading',{staticClass:"loading-section",attrs:{"color":"#a54eae","text":"Loading..."}})],1):_c('DownloadView',{attrs:{"type":'questionnaire'}})}
var staticRenderFns = []

export { render, staticRenderFns }